import { render, staticRenderFns } from "./FrameworkView.vue?vue&type=template&id=6402e7be&"
import script from "./FrameworkView.vue?vue&type=script&lang=js&"
export * from "./FrameworkView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports